/* eslint-disable max-len */
import { DeleteOutlined, DownOutlined, EditOutlined } from '@ant-design/icons';
import { Dropdown, Menu, Button, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { type ConsentsAndDeclarationsModuleSpecsFragment } from '../../../../api/fragments/ConsentsAndDeclarationsModuleSpecs';
import { type PermissionValues } from '../../../../utilities/hasPermissions';
import useDeleteModule from '../useDeleteModule';
import { useUpdateConsentsModuleDrawer } from './UpdateConsentsModuleDrawer';

export type ConsentsAndDeclarationsModuleActionsProps = {
    module: ConsentsAndDeclarationsModuleSpecsFragment;
    permissions: Pick<PermissionValues, 'hasDeletePermission' | 'hasUpdatePermission'>;
};

const ConsentsAndDeclarationsModuleActions = ({ module, permissions }: ConsentsAndDeclarationsModuleActionsProps) => {
    const { t } = useTranslation(['consentsAndDeclarationsModuleDetails', 'moduleDetails']);
    const deleteModule = useDeleteModule(module.id);

    const updateConsentsModuleDrawer = useUpdateConsentsModuleDrawer(module);
    const { hasUpdatePermission, hasDeletePermission } = permissions;

    const items = [
        hasUpdatePermission && {
            label: t('consentsAndDeclarationsModuleDetails:mainActionButtons.updateSpecs'),
            key: 'updateSpecs',
            icon: <EditOutlined />,
            onClick: updateConsentsModuleDrawer.open,
        },
        hasDeletePermission && {
            label: t('consentsAndDeclarationsModuleDetails:mainActionButtons.delete'),
            key: 'delete',
            icon: <DeleteOutlined />,
            onClick: deleteModule,
            danger: true,
        },
    ].filter(Boolean);

    if (!items.length) {
        return null;
    }

    return (
        <>
            <Dropdown overlay={<Menu items={items} />}>
                <Button type="primary">
                    <Space>
                        <span>{t('consentsAndDeclarationsModuleDetails:mainActionButtons.actions')}</span>
                        <DownOutlined />
                    </Space>
                </Button>
            </Dropdown>
            {updateConsentsModuleDrawer.render()}
        </>
    );
};

export default ConsentsAndDeclarationsModuleActions;
